import type { TFunction } from 'i18next';
import type { ICampaignAnalysis } from '@app/dashboard/types/innerLayout/reach';
import type { IColumnsMap } from 'libs/design-system/src/types/data_table';

import { singleCampaignRenderBox } from '@app/dashboard/views/pages/inner_layout/Reach/utils';
import { truncateLongText } from '@app/dashboard/utils/truncateLongText';

export const TABLE_HEADER_DEFINITIONS = (t: TFunction): IColumnsMap => [
  {
    id: 'id',
    name: t('innerLayout.reach.campaigns.table.headers.campaignId'),
    type: 'text',
    key: 'id',
  },
  {
    id: 'title',
    name: t('innerLayout.reach.campaigns.table.headers.title'),
    type: 'text',
    key: 'title',
    format: (obj: any, value: any) => {
      return truncateLongText(value as string);
    },
  },
  {
    id: 'content',
    name: t('innerLayout.reach.campaigns.table.headers.content'),
    type: 'text',
    key: 'content',
    format: (obj: any, value: any) => {
      return truncateLongText(value as string);
    },
  },
  {
    id: 'channel',
    name: t('innerLayout.reach.campaigns.table.headers.channel'),
    type: 'text',
    key: 'channel',
  },
  {
    id: 'total_customers',
    name: t('innerLayout.reach.campaigns.table.headers.totalCustomers'),
    type: 'text',
    key: 'total_customers',
  },
  {
    id: 'start_date',
    name: t('innerLayout.reach.campaigns.table.headers.startDate'),
    type: 'date',
    key: 'start_date',
    hintText: 'start_date',
  },
  {
    id: 'approved_date',
    name: t('innerLayout.reach.campaigns.table.headers.approvalDate'),
    type: 'date',
    key: 'approved_date',
    hintText: 'approved_date',
  },
  {
    id: 'status',
    name: t('innerLayout.reach.campaigns.table.headers.status'),
    type: 'badge',
    key: 'is_terminated',
    labelComparingValue: 'is_terminated',
    label: {
      false: {
        color: 'green',
        text: t('innerLayout.reach.campaigns.table.status.active'),
      },
      true: {
        color: 'red',
        text: t('innerLayout.reach.campaigns.table.status.hold'),
      },
    },
    format: (obj: any, value: any) => {
      return value === true ? 'true' : 'false';
    },
  },
  {
    id: 'send',
    name: t('innerLayout.reach.campaigns.table.headers.send'),
    type: 'badge',
    key: 'is_sent',
    labelComparingValue: 'is_sent',
    label: {
      ['True']: {
        color: 'green',
        text: t('innerLayout.reach.campaigns.table.status.sent'),
      },
      ['False']: {
        color: 'red',
        text: t('innerLayout.reach.campaigns.table.status.notSent'),
      },
    },
  },
  {
    id: 'approved',
    name: t('innerLayout.reach.campaigns.table.headers.approved'),
    type: 'badge',
    key: 'is_approved',
    labelComparingValue: 'is_approved',
    label: {
      ['True']: {
        color: 'green',
        text: t('innerLayout.reach.campaigns.table.status.approved'),
      },
      ['False']: {
        color: 'red',
        text: t('innerLayout.reach.campaigns.table.status.unApproved'),
      },
    },
  },
];

export const BOXES_CAMPAIGNS_STATICS = (
  t: TFunction,
  campaignStaticsData: { data: { data: ICampaignAnalysis } }
) => [
  {
    text: t(
      'innerLayout.reach.campaigns.singleCampaignPage.statics.boxes.totalCustomers'
    ),
    value: singleCampaignRenderBox({
      key: 'total_count',
      campaignStaticsData,
    }),
  },
  {
    text: t(
      'innerLayout.reach.campaigns.singleCampaignPage.statics.boxes.smsCount'
    ),
    value: singleCampaignRenderBox({
      key: 'total_sms_count',
      campaignStaticsData,
    }),
  },
  {
    text: t(
      'innerLayout.reach.campaigns.singleCampaignPage.statics.boxes.successSms'
    ),
    value: singleCampaignRenderBox({
      key: 'success_count',
      campaignStaticsData,
    }),
  },
  {
    text: t(
      'innerLayout.reach.campaigns.singleCampaignPage.statics.boxes.failedSms'
    ),
    value: singleCampaignRenderBox({
      key: 'failed_count',
      campaignStaticsData,
    }),
  }
];

export const BOXES_CAMPAIGNS_ANALYSIS_STATICS = (
  t: TFunction,
  campaignStaticsData: { data: { data: ICampaignAnalysis } }
) => [
  {
    text: t('innerLayout.reach.campaignsAnalysis.boxes.totalCampaigns'),
    value: singleCampaignRenderBox({
      key: 'campaign_count',
      campaignStaticsData,
    }),
  },
  {
    text: t('innerLayout.reach.campaignsAnalysis.boxes.totalCustomers'),
    value: singleCampaignRenderBox({
      key: 'total_phone_numbers',
      campaignStaticsData,
    }),
  },
  {
    text: t('innerLayout.reach.campaignsAnalysis.boxes.successSms'),
    value: singleCampaignRenderBox({
      key: 'sent_campaigns',
      campaignStaticsData,
    }),
  },
  {
    text: t('innerLayout.reach.campaignsAnalysis.boxes.failedSms'),
    value: singleCampaignRenderBox({
      key: 'unsent_campaigns',
      campaignStaticsData,
    }),
  },
];

export const MODAL_STEP_STATUS = {
  START: 'start',
  SUCCESS: 'success',
  FAILED: 'failed',
};
